module.exports = {
	"coffee": [
		{
			"date": "20170301",
			"drinks": [
				{
					"time": "08:02",
					"amount": 16,
					"roaster": "Rival Brothers",
					"variety": "Love Park Roast",
					"method": "Chemex",
					"container": "blue Zojirushi travel mug",
					"location": "Manayunk"
				}
			]
		},
		{
			"date": "20170302",
			"drinks": [
				{
					"time": "07:59",
					"amount": 16,
					"roaster": "Rival Brothers",
					"variety": "Love Park Roast",
					"method": "Chemex",
					"container": "blue Zojirushi travel mug",
					"location": "Manayunk"
				}
			]
		},
		{
			"date": "20170303",
			"drinks": [
				{
					"time": "10:34",
					"amount": 12,
					"roaster": "Elixr",
					"variety": "Costa Rica - El Roble",
					"method": "Chemex",
					"container": "paper to go cup",
					"location": "Elixr"
				}
			]
		},
		{
			"date": "20170304",
			"drinks": [
				{
					"time": "06:14",
					"amount": 2.5,
					"roaster": "Rival Brothers",
					"variety": "Costa Rica - Las Lajas",
					"method": "Espresso",
					"container": "white ceramic cup",
					"location": "Manayunk"
				},
				{
					"time": "10:34",
					"amount": 12,
					"roaster": "Buddy Brew",
					"variety": "",
					"method": "Cold Brew",
					"container": "plastic to go cup",
					"location": "Buddy Brew - TPA"
				}
			]
		},
		{
			"date": "20170305",
			"drinks": [
				{
					"time": "09:34",
					"amount": 8,
					"roaster": "Counter Culture",
					"variety": "Apollo",
					"method": "Aeropress",
					"container": "Poler camping cup",
					"location": "Indian Rocks Beach"
				},
				{
					"time": "10:49",
					"amount": 8,
					"roaster": "Buddy Brew",
					"variety": "Ethiopia - Guji - Sidama",
					"method": "Aeropress",
					"container": "Poler camping cup",
					"location": "Indian Rocks Beach"
				}
			]
		},
		{
			"date": "20170306",
			"drinks": [
				{
					"time": "09:34",
					"amount": 8,
					"roaster": "Counter Culture",
					"variety": "Apollo",
					"method": "Aeropress",
					"container": "Poler camping cup",
					"location": "Indian Rocks Beach"
				},
				{
					"time": "10:49",
					"amount": 8,
					"roaster": "Buddy Brew",
					"variety": "Ethiopia - Guji - Sidama",
					"method": "Aeropress",
					"container": "Poler camping cup",
					"location": "Indian Rocks Beach"
				}
			]
		},
		{
			"date": "20170307",
			"drinks": [
				{
					"time": "08:21",
					"amount": 8,
					"roaster": "Counter Culture",
					"variety": "Apollo",
					"method": "Aeropress",
					"container": "Poler camping cup",
					"location": "Indian Rocks Beach"
				}
			]
		},
		{
			"date": "20170308",
			"drinks": [
				{
					"time": "08:18",
					"amount": 8,
					"roaster": "Buddy Brew",
					"variety": "Ethiopia - Guji - Sidama",
					"method": "Aeropress",
					"container": "Poler camping cup",
					"location": "Indian Rocks Beach"
				},
				{
					"time": "10:21",
					"amount": 8,
					"roaster": "Counter Culture",
					"variety": "Apollo",
					"method": "Aeropress",
					"container": "Poler camping cup",
					"location": "Indian Rocks Beach"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/coffee.json
// module id = 212
// module chunks = 0